import { onBeforeUnmount, onMounted, ref, watch } from 'vue'

type ResizableDialogOptions = {
  defaultWidth: number
  defaultHeight: number
  minWidth: number
  minHeight: number
}

export const useResizableDialog = ({
  defaultWidth,
  defaultHeight,
  minWidth,
  minHeight,
}: ResizableDialogOptions) => {
  const dialogWidth = ref(defaultWidth)
  const dialogHeight = ref(defaultHeight)

  const clampDialogSize = () => {
    if (typeof window === 'undefined') return

    const maxWidth = Math.max(minWidth, Math.floor(window.innerWidth * 0.95))
    const maxHeight = Math.max(minHeight, Math.floor(window.innerHeight * 0.95))

    dialogWidth.value = Math.min(Math.max(dialogWidth.value, minWidth), maxWidth)
    dialogHeight.value = Math.min(Math.max(dialogHeight.value, minHeight), maxHeight)
  }

  onMounted(() => {
    clampDialogSize()
    window.addEventListener('resize', clampDialogSize)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', clampDialogSize)
  })

  watch([dialogWidth, dialogHeight], clampDialogSize)

  return {
    dialogWidth,
    dialogHeight,
    dialogMinWidth: minWidth,
    dialogMinHeight: minHeight,
    clampDialogSize,
  }
}
